<template>
  <div>
      <b-button
          v-if="dataObj.actionButton"
          :id="$route.name + '-tabs-add-new-location'"
          size="md"
          @click.prevent="onActionItemClicked(dataObj.actionButton)"
          class="ss-warning-bg border-0 mb-2"
        >
          <i class="fa fa-plus u-mr-xsmall"></i>
          {{ dataObj.actionButton.menuTitle }}
        </b-button> 
    <tablelisttab v-if="listDataObj.table" :list-data-obj="listDataObj" :data-obj="dataObj" @update="updatelistDataObj" :table-id="componentTableName"></tablelisttab>
  </div>
</template>

<script>
  //Standard Components
  import EVENTS from "@/constants/events";
  import ApplicationService from "@/services/application";
  //Template Layout Components
  import tablelisttab from "@/components/_universal/list-table-tab.vue";

  import editMixin from "@/mixin/edit-mixin";
  import GlobalServices from "@/services/global";

let global = new GlobalServices();
  const app = new ApplicationService();

  export default {
    mixins: [editMixin],
    data() {
      return {
        listDataObj: {},
        sidePanelDataObj: {},
        EVENT_ACTION: {},
        componentTableName: null,
        headersLoaded: false // Track if headers have been loaded
      };
    },
  methods: {
       onActionItemClicked(action) {
        app.actionNavigation(action);
      },
      async loadData(forceHeaderReload = false) {
        // Only fetch headers on initial load or when forced
        if (!this.headersLoaded || forceHeaderReload) {
          //Set Header Properties to be passed in as prop values, second paramater set to true to indicate we're calling action from a list:isTabList
          this.listDataObj = await global.getDataByActionId(this.dataObj.param, true);
          this.headersLoaded = true;
        } else {
          // For polling, only fetch data without headers
          await this.loadDataOnly();
        }
      },
      
      async loadDataOnly() {
        try {
          // Fetch only the data without headers for polling optimization
          const data = await global.getTabTableleDataByActionId(this.dataObj.param);
          if (this.listDataObj.table) {
            this.listDataObj.table.data = data;
          }
        } catch (e) {
          // Fallback to full data load if needed
          await this.loadData(true);
        }
      },
      
      updatelistDataObj(results) {
        this.listDataObj = results;
      },
    },
    components: {
      tablelisttab,
    },
    async mounted() {
      //ONLY TRACK EVENTS IN PRODUCTION
      // if (process.env.VUE_APP_ENVIRONMENT === "production") {
      //   window["analytics"].page(this.EVENT_ACTION.CLIENTS.View);
      // }
      const name = this.dataObj.title
      this.componentTableName = name.replace(" ", "-").replace("/", "-").toLowerCase();

      this.$root.$on(this.closeEvent, this.loadData);

      let sidePanel = this.$store.getters.getSidePanel;

      //Ensure the side bar is open
      if (sidePanel.isOpen === true) {
        this.timer = setInterval(async () => {
          await this.loadDataOnly(); // Use optimized data-only loading for polling
        }, 15000);
      }
    },
    async created() {
      //Import event constants and set local variable
      this.EVENT_ACTION = EVENTS;
      await this.loadData(true); // Force header load on initial creation
    },
  };
</script>
